export class MegapushUtils {
    public static transformContent(content: string, isMobile?: boolean): string {
        const pattern: any = {
            '[bold]': '<strong>',
            '[/bold]': '</strong>',
            '[color]': '<span class="text-primary">',
            '[/color]': '</span>',
            '[prix]': `${
                isMobile
                    ? '<div class="ob1-price  ob1-price-compact" data-ob1-component="Price"> <span class="ob1-price-amount">'
                    : '<div class="ob1-price" data-ob1-component="Price"> <span class="ob1-price-amount">'
            }`,
            '[/prix]': '&nbsp;</span></div>',
            '[retour]': '</br>',
        };

        if (!content) {
            return '';
        }
        return content?.replace(
            /\[bold]|\[\/bold]|\[color]|\[\/color]|\[prix]|\[\/prix]|\[retour]/g,
            (matched) => pattern[matched],
        );
    }
}
